// extracted by mini-css-extract-plugin
export default {"dltContainer":"ItemModal_dltContainer__NerCl","btnContainer":"ItemModal_btnContainer__TSHJ8","confirmBtn":"ItemModal_confirmBtn__P4OZt","cancelBtn":"ItemModal_cancelBtn__ebfRl"};